<p>
  filter-currency works!
</p>
